import React from "react"

const ModalCloseBtn = ({ handleClose, addrightMargin }) => {
	return (
		<button id={"customCloseModal"} className={addrightMargin ? "me-2" : null} onClick={() => handleClose()}><span>×</span></button>
	)
}
export default ModalCloseBtn
